window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.utils = {
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  wrap: function(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function(wait, callback, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    }
  },

  throttle: function(limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    }
  },

  prepareTransition: function(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function(array) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
 * - getBaseUnit - Splits unit price apart to get value + unit
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}';
  var superScript = theme && theme.settings && theme.settings.superScriptPrice;

  function formatMoney(cents, format) {
    if (!format) {
      format = theme.settings.moneyFormat;
    }

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);

        if (superScript && value && value.includes('.')) {
          value = value.replace('.', '<sup>') + '</sup>';
        }

        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');

        if (superScript && value && value.includes('.')) {
          value = value.replace(',', '<sup>') + '</sup>';
        }

        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  }
})();

var productMediaWrapper = {
  init: function(){
    var wrap = $('.product__media-gallery');
    var product_template_id = wrap.data('section');
    var enable_video_gallery = wrap.data('enable-video-gallery');
    var thumbnailId = '#Slider-Thumbnails-' + product_template_id;
    var thumbnailCarousel = document.querySelector(thumbnailId);
    var sliderGalleryID = '#Slider-Gallery-' + product_template_id;

    var productSliderGallery = $(sliderGalleryID).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: false,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="far fa-angle-left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="far fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            
          }
        }
      ]
    });

    if(enable_video_gallery){
      productSliderGallery.slick('slickGoTo', 0);
    }else{
      wrap.addClass('slider-active');
    }
    
    $(thumbnailId).find('.thumbnail-list__item').eq(0).addClass('thumb-active');

    productSliderGallery.on('afterChange', function(event, slick, currentSlide, nextSlide){
      var c_s = currentSlide + 1;
      var selectedItemBounding = thumbnailCarousel.querySelector('[data-media-position="' + c_s + '"]').getBoundingClientRect();
      var thumbnailSlideBounding = thumbnailCarousel.getBoundingClientRect();
      
      $('.thumb-active').removeClass('thumb-active');
      $(thumbnailId).find('[data-media-position="' + c_s + '"]').addClass('thumb-active');
      wrap.addClass('slider-active');
      (selectedItemBounding.x + selectedItemBounding.width > thumbnailSlideBounding.x + thumbnailSlideBounding.width || selectedItemBounding.x < thumbnailSlideBounding.x) && (thumbnailCarousel.scrollLeft += selectedItemBounding.x - thumbnailSlideBounding.x - thumbnailSlideBounding.width / 2);
    });

    // $('body').on('click', '.thubmnail-arrow', function(){
    //   var btnType = $(this).attr('data-type');

    //   if(btnType == 'prev'){        
    //     var leftOffset = thumbnailCarousel.scrollLeft;
    //     thumbnailCarousel.scrollLeft = Math.max(0, leftOffset - 150);
    //   }else{
    //     var leftOffset = thumbnailCarousel.scrollLeft;
    //     var liveOffset = thumbnailCarousel.scrollWidth;
    //     thumbnailCarousel.scrollLeft = Math.min(liveOffset, leftOffset + 150);
    //   }
    // })

    // $(document).ready(function () {
    //   updateArrowStates();
    
    //   // On button click, handle scroll and state updates
    //   $('body').on('click', '.thubmnail-arrow', function () {
    //     var btnType = $(this).attr('data-type');
    //     var leftOffset = thumbnailCarousel.scrollLeft;
    //     var maxOffset = thumbnailCarousel.scrollWidth - thumbnailCarousel.clientWidth;
    
    //     if (btnType === 'prev') {
    //       thumbnailCarousel.scrollLeft = Math.max(0, leftOffset - 150);
    //     } else {
    //       thumbnailCarousel.scrollLeft = Math.min(maxOffset, leftOffset + 150);
    //     }
    //   });
    
    //   // Listen for scroll events and update states
    //   thumbnailCarousel.addEventListener('scroll', updateArrowStates);
    
    //   // Function to check and update arrow button states
    //   function updateArrowStates() {
    //     var leftOffset = thumbnailCarousel.scrollLeft;
    //     var maxOffset = thumbnailCarousel.scrollWidth - thumbnailCarousel.clientWidth;
    
    //     // Check for prev button
    //     if (leftOffset <= 0) {
    //       $('.thubmnail-arrow[data-type="prev"]').addClass('disabled');
    //     } else {
    //       $('.thubmnail-arrow[data-type="prev"]').removeClass('disabled');
    //     }
    
    //     // Check for next button
    //     if (leftOffset >= maxOffset) {
    //       $('.thubmnail-arrow[data-type="next"]').addClass('disabled');
    //     } else {
    //       $('.thubmnail-arrow[data-type="next"]').removeClass('disabled');
    //     }
    //   }
    // });

$(document).ready(function () {
    updateArrowStates();

    // On button click, handle scroll and state updates
    $('body').on('click', '.thubmnail-arrow', function () {
        var btnType = $(this).attr('data-type');
        var leftOffset = thumbnailCarousel.scrollLeft;
        var maxOffset = Math.max(0, thumbnailCarousel.scrollWidth - thumbnailCarousel.clientWidth);

        if (btnType === 'prev') {
            thumbnailCarousel.scrollLeft = Math.max(0, leftOffset - 150);
        } else {
            thumbnailCarousel.scrollLeft = Math.min(maxOffset, leftOffset + 150);
        }
    });

    // Listen for scroll events and update states
    thumbnailCarousel.addEventListener('scroll', updateArrowStates);

    // Function to check and update arrow button states
    function updateArrowStates() {
        var leftOffset = Math.ceil(thumbnailCarousel.scrollLeft); // Round up
        var maxOffset = Math.ceil(thumbnailCarousel.scrollWidth - thumbnailCarousel.clientWidth); // Round up

        console.log('leftOffset:', leftOffset, 'maxOffset:', maxOffset); // Debugging log

        // If scrolling is not needed, disable both arrows
        if (thumbnailCarousel.scrollWidth <= thumbnailCarousel.clientWidth) {
            $('.thubmnail-arrow[data-type="next"]').addClass('disabled');
            $('.thubmnail-arrow[data-type="prev"]').addClass('disabled');
            console.log('Both arrows disabled due to no scrolling needed.');
            return; // No need to check further
        }

        // Check for prev button
        if (leftOffset <= 0) {
            $('.thubmnail-arrow[data-type="prev"]').addClass('disabled');
            console.log('prev navigation disabled');
        } else {
            $('.thubmnail-arrow[data-type="prev"]').removeClass('disabled');
            console.log('prev navigation remove');
        }

        // Check for next button
        if (leftOffset >= maxOffset) {
            $('.thubmnail-arrow[data-type="next"]').addClass('disabled');
            console.log('next navigation disabled');
        } else {
            $('.thubmnail-arrow[data-type="next"]').removeClass('disabled');
            console.log('next navigation remove');
        }
    }
});




    
    $('body').on('click', '.thumbnail-list__item', function(){
      var position = $(this).attr('data-media-position');
      
      $('.thumb-active').removeClass('thumb-active');
      $(this).addClass('thumb-active');
      productSliderGallery.slick('slickGoTo', parseInt(position) - 1);
    });

    $('.js-media-zoom').on('click', function(){
      var image = $(this).find('img');
      
      if(image.hasClass('isZooming')){
        image.removeAttr('style');
        image.removeClass('isZooming');
        $(this).removeClass('is-zoomed');
      }else{
        image.css('top', 0);
        image.css('left', 0);
        image.css('transform', 'scale(1.5)');
        image.addClass('isZooming');
        $(this).addClass('is-zoomed');
      }
    });

    $('.js-media-zoom').on('mousemove', function(e){
      var image = $(this).find('img');
      var imageOffset = image.offset();
      var imageWidth = image.width();
      var imageHiehgt = image.height();
      var parentOffset = $(this).offset();
      var parentWidth = $(this).width();
      var parentheight = $(this).height();
      var xRatio = imageWidth / parentWidth;
      var yRatio = imageHiehgt / parentheight;
      
      if(image.hasClass('isZooming')){
        var tagerOffsetY = (parentheight / 2) - e.offsetY;
        var tagerOffsetX = (parentWidth / 2) - e.offsetX;
        
        image.css('top', tagerOffsetY + 'px');
        image.css('left', tagerOffsetX + 'px');
        image.css('transform', 'scale(1.5)');
      }
    });

    $('.js-media-zoom').on('mouseleave', function(){
      var image = $(this).find('img');
      if(image.hasClass('isZooming')){
        image.removeAttr('style');
        image.removeClass('isZooming');
        $(this).removeClass('is-zoomed');
      }
    })
  },
  color_swatch_slider: function(){
    $('.product-color-option-slider').slick({
      infinite: false,
      dots: false,
      slidesToShow: 8,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="far fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="far fa-angle-right"></i></button>'
    });
  },
  change_gallery_position: function(target, position){
    var wrap = $('.product__media-gallery');
    var product_template_id = wrap.data('section');
    var enable_video_gallery = wrap.data('enable-video-gallery');
    //console.log(position);

    if(enable_video_gallery) {
      var posi = position;
    }else{
      var posi = position - 1;
    }
      
    if(target){
      target.slick('slickGoTo', posi);
    }
  }
}

var productForm = {
  init: function(){
    var mainProductinfo = document.querySelector('.product__info-wrapper');
    var mainProductsection = document.querySelector('.main-product-wrap');
    var product_form = mainProductsection.querySelector('form[action="/cart/add"]');
    const submitButton = product_form.querySelector('[type="submit"]');
    var selectItem = $('.select-product-custom-product-item .first-option');

    $('body').on('click','.select-product-custom-product-item .first-option', function(){
      $('.select-product-custom-product-item').removeClass('select-product-custom-product-item--showlist');
      $(this).closest('.select-product-custom-product-item').addClass('select-product-custom-product-item--showlist');
      productForm.product_customization_count();
    })

    $('body').on('click','.select-product-custom-product-item .option', function(){
      var text = $(this).text();
      var count = $(this).attr('data-count') || 0;
      var parent = $(this).closest('.product-custom-selector__field');
      var title = parent.find('.customizer-option-title').text();

      $(product_form).find(`input[name="properties[${title}]"]`).remove();
      if(text == 'None' || text == 'Please select an option'){
        if($(this).hasClass('option-product-custom-product-item')){
          parent.find('.first-option').text(text);
          parent.attr('value', text);
          parent.attr('data-count', count);
          parent.find('.select-product-custom-product-item').addClass('selected-product-custom');
          $(product_form).prepend(`<input type="hidden" name="properties[${title}]" value="${text}">`);
          parent.removeClass('not-valid');
        }else{
          parent.find('.first-option').text(text);
          parent.removeAttr('value');
          parent.removeAttr('data-count');
          parent.find('.select-product-custom-product-item').removeClass('selected-product-custom');
          if(parent.hasClass('js-option-required')){
            parent.addClass('not-valid');
          }
        }
      }else{
        parent.find('.first-option').text(text);
        parent.attr('value', text);
        parent.attr('data-count', count);
        parent.find('.select-product-custom-product-item').addClass('selected-product-custom');
        $(product_form).prepend(`<input type="hidden" name="properties[${title}]" value="${text}">`);
        parent.removeClass('not-valid');
      }
      parent.find('.select-product-custom-product-item').removeClass('select-product-custom-product-item--showlist');

      productForm.product_customization_count();
      productForm.product_price_update();
      productForm.product_installment_update();
    });

    $(document).mouseup(function (e){

      var container = $(".product-custom-dropdown");
  
      if (!container.is(e.target) && container.has(e.target).length === 0){
        $('.select-product-custom-product-item').removeClass('select-product-custom-product-item--showlist');
      }
    });

    $('.product-custom-note__input').keyup(function(){
      var value = $(this).val();
      var title = $(this).closest('.product-custom-selector__field').find('.customizer-option-title').text();

      $(product_form).find(`input[name="properties[${title}]"]`).remove();
      if(value == ''){
        $(this).closest('.product-custom-note__text').removeClass('added-note');
      }else{
        $(this).closest('.product-custom-note__text').addClass('added-note');
        $(product_form).prepend(`<input type="hidden" name="properties[${title}]" value="${value}">`);
      }
      productForm.product_customization_count();
    })

    $('body').on('click','.select-form__quantity-selected', function(){
      $(this).closest('.product-form__quantity-select').find('.select-form__quantity').addClass('showlist');
      productForm.product_customization_count();      
    })

    $('body').on('click','.select-form__quantity .option', function(){
      var value = $(this).text();

      $(this).closest('.product-form__quantity-selector').find('.select-form__quantity-selected .value').attr('data-value', parseInt(value)).text(parseInt(value));
      $(this).closest('.select-form__quantity').removeClass('showlist');

      if(parseInt(value) > 9){
        $(this).closest('.product-form__quantity-selector').addClass('qty-offset');
      }

      $(product_form).find('input[name="quantity"]').val(parseInt(value));
      productForm.product_customization_count();
      productForm.product_price_update();
      productForm.product_installment_update();
    })

    // Close dropdown when clicking outside
    $(document).on("click", function(event) {
      if (!$(event.target).closest(".select-form__quantity, .select-form__quantity-selected").length) {
        $(".select-form__quantity").removeClass("showlist");
      }
    });

    $('body').on('click','.product-form__quantity-button', function(){
      var dataType = $(this).data('type');
      var dataVal = $(this).closest('.product-form__quantity-input').find('.product-form__quantity-display').text();

      if(dataType == 'plus'){
        $(this).closest('.product-form__quantity-input').find('.product-form__quantity-display').text(parseInt(dataVal) + 1);
        $(this).closest('.product-form__quantity-selector').find('.select-form__quantity-selected .value').attr('data-value', parseInt(dataVal) + 1).text(parseInt(dataVal) + 1);
        $(product_form).find('input[name="quantity"]').val(parseInt(dataVal) + 1);
      }else{
        if(parseInt(dataVal) > 10){
          $(this).closest('.product-form__quantity-input').find('.product-form__quantity-display').text(parseInt(dataVal) - 1);
          $(this).closest('.product-form__quantity-selector').find('.select-form__quantity-selected .value').attr('data-value', parseInt(dataVal) - 1).text(parseInt(dataVal) - 1);
          $(product_form).find('input[name="quantity"]').val(parseInt(dataVal) - 1);
        }else{
          $(this).closest('.product-form__quantity-selector').removeClass('qty-offset');
        }
      }
      productForm.product_customization_count();
      productForm.product_price_update();
      productForm.product_installment_update();
    })

    /* attach event listener to the product form */
    // document.addEventListener('upload:added', function(e) {
    //   $('.cl-upload--wrapper').find('input[name^=properties]').each(function(){
    //     $(this).closest('.product__info-container').find('form[action="/cart/add"]').prepend($(this));
    //   });
    // });


    // product form submit
    product_form.addEventListener('submit', function(evt){
      evt.preventDefault();

      var optionRequiredValid = false;
      $(mainProductinfo).find('.js-option-required').each(function(){
        if($(this).attr('value')){
          console.log('valid');
        }else{
          optionRequiredValid = true;
          $(this).addClass('not-valid');
          console.log('no valid');
        }
      });

      if (optionRequiredValid) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(mainProductsection).offset().top
        }, 500);
        return;
      }
      if (submitButton.classList.contains('loading')) return;
      

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
  
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(evt.target)),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          productForm.product_gta_filter();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally((response) => {
          productForm.product_addons_cart();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');

          var deleteBtns = document.querySelectorAll(".product-custom-upload__upload-new-wrapper .cl-upload--wrapper .cl-upload--area .filepond--list-scroller ul.filepond--list li.filepond--item button:not([disabled])");
          deleteBtns.forEach(function(e) {
            e.click();
          });
        });
    })
  },
  product_customization_count: function(){
    var count = 0;
    var mainProductsection = document.querySelector('.main-product-wrap');
    var product_form = mainProductsection.querySelector('form[action="/cart/add"]');

    $(product_form).find('[name="properties[Custom Count]"]').remove();
    $('.js-option-required').each(function(){
      var j_count = $(this).attr('data-count') || 0;

      j_count = parseInt(j_count);
      count += j_count;
    });
    if (count > 0) {
      $(product_form).prepend(`<input type="hidden" name="properties[Custom Count]" value="${count}">`);
    }
  },
  product_addons_cart: function(){
    var bundle = [];
    var customizeId = window.customization.product.id;
    var parent = $('.main-product-wrap');
    var sectionid = parent.attr('data-section');
    var currentVariant = productForm.getVariantFromOptions(sectionid);
    var total_custom_counts = 0;
    var qty = parseInt(parent.find('.select-form__quantity-selected .value').attr('data-value'));

    $('.product-addons').find('.addon-card__toggle').each(function(){
      var id = $(this).attr('data-variant-id');
      if($(this).closest('.addon-card__actions').hasClass('active')){
        bundle.push({'id':id,'quantity':1});
      }
    });

    $('.js-option-required').each(function(){
      var count = $(this).attr('data-count') || 0;

      total_custom_counts = total_custom_counts + parseInt(count);
    })
    
    bundle.push({'id':customizeId, 'quantity':total_custom_counts * qty, 'properties': {'Customization costs for:': currentVariant.title}});
    
    if(bundle.length > 0){
      $.ajax({
          url:'/cart/add.js',
          method:'POST',
          dataType:'json',
          data:{'items': bundle},
          success:function(succ){
            cart_slide_update();
          },
          error:function(er) {
            console.log(er)
            alert('Something went wrong.');
          }
      });
    }else{
      cart_slide_update();
    }
  },
  product_gta_filter: function(){
    $.ajax({
        url:'/cart.js',
        method:'GET',
        dataType:'json',
        success:function(succ){
          var items = [];

          succ.items.forEach(function(item){
            var product_item = {id: item.id, name: item.product_title, price: item.price, properties: item.properties, quantity: item.quantity, subscriptionFrequency: false};
            items.push(product_item);
          })
          window.dataLayer.push({ ecommerce: null }),
          window.dataLayer.push({ event: "addToCart", ecommerce: { currencyCode: "USD", add: { products: items } } }),
          window.dataLayer.push({ event: "add_to_cart", ecommerce: { items: items } });
        },
        error:function(er) {
          console.log(er)
          alert('Something went wrong.');
        }
    });
  },
  product_installment_update: function(target){
    var parent = $('.main-product-wrap');
    var sectionid = parent.attr('data-section');
    var selected_total_price = 0;
    var total_price = 0;
    var install_price = 0;
    var currentVariant = productForm.getVariantFromOptions(sectionid);
    var addonWrap = $(`#product-modal-${currentVariant.id}-addons`);
    var product_form = $('#product-form-' + sectionid);
    var qty = parseInt(parent.find('.select-form__quantity-selected .value').attr('data-value'));

    $('.js-option-required').each(function(){
      var count = $(this).attr('data-count') || 0;

      total_price = total_price + parseInt(count) * 100;
    })
    
    addonWrap.find('.addon-card__actions').each(function(){
      var price = $(this).find('.addon-card__toggle').attr('data-variant-price');
      if($(this).hasClass('active')){
        total_price = total_price + parseInt(price);
      }
    })
    total_price = total_price + currentVariant.price * qty;
    install_price = total_price / 4;

    $('shopify-payment-terms').remove();
    var installmentWidget = `<shopify-payment-terms variant-id="${currentVariant.id}" shopify-meta='{"type":"product","variants":[{"id":${currentVariant.id},"price":"${theme.Currency.formatMoney(install_price, window.settings.moneyFormat)}","dynamic_pdp_price":"${theme.Currency.formatMoney(total_price, window.settings.moneyFormat)}","eligible":true,"available_loan_types":["interest"]}],"min_price":"$50.00","max_price":"$17,500.00","number_of_payment_terms":4,"dynamic_pdp_enabled":true,"financing_plans":[{"min_price":"$50.00","max_price":"$149.99","terms":[{"apr":0,"installments_count":4,"loan_type":"split_pay"}]},{"min_price":"$150.00","max_price":"$999.99","terms":[{"apr":0,"installments_count":4,"loan_type":"split_pay"},{"apr":15,"installments_count":6,"loan_type":"interest"},{"apr":15,"installments_count":12,"loan_type":"interest"}]},{"min_price":"$1,000.00","max_price":"$17,500.00","terms":[{"apr":15,"installments_count":3,"loan_type":"interest"},{"apr":15,"installments_count":6,"loan_type":"interest"},{"apr":15,"installments_count":12,"loan_type":"interest"}]}]}'></shopify-payment-terms>`;
    $('.shop_pay').append(installmentWidget);
  },
  product_price_update: function(){
    var parent = $('.main-product-wrap');
    var sectionid = parent.attr('data-section');
    var total_price = 0;
    var total_sale_price = 0;
    var currentVariant = productForm.getVariantFromOptions(sectionid);
    var addonWrap = $(`#product-modal-${currentVariant.id}-addons`);
    var qty = parseInt(parent.find('.select-form__quantity-selected .value').attr('data-value'));
    var priceContent = '';

    //console.log(currentVariant);

    $('.js-option-required').each(function(){
      var count = $(this).attr('data-count') || 0;

      total_price = total_price + parseInt(count) * 100 * qty;
    })
    
    addonWrap.find('.addon-card__actions').each(function(){
      var price = $(this).find('.addon-card__toggle').attr('data-variant-price');
      if($(this).hasClass('active')){
        total_price = total_price + parseInt(price);
      }
    });

    total_sale_price = total_price + currentVariant.compare_at_price * qty;
    total_price = total_price + currentVariant.price * qty;
    priceContent = `${theme.Currency.formatMoney(total_price, window.settings.moneyFormat)}`;
    if(total_sale_price > total_price){
      priceContent = `<span class="product_compare_at_price">${theme.Currency.formatMoney(total_sale_price, window.settings.moneyFormat)}</span><span class="product_compare_at_price--02">${theme.Currency.formatMoney(total_price, window.settings.moneyFormat)}</span>`;
    }   
    $('.product-form__addon-price .product_price,.price.price--large .price-item').html(priceContent); 
  },
  getVariantFromOptions: function(id) {
    var result = [];
    var productInfo = $('#ProductInfo-' + id);
    var optionWrap = productInfo.find('.variant-radios-wrapper');
    var productJson = JSON.parse($('#ProductJSON-' + id).html());
    var found = false;

    optionWrap.find('fieldset').each(function(index){
      result.push({
        value: $(this).find('input:checked').val(),
        index: 'option' + (index + 1)
      });
    });

    productJson.variants.forEach(function(variant) {
      var match = true;
      var options = variant.options;

      result.forEach(function(option) {
        if (match) {
          match = (variant[option.index] === option.value);
        }
      });

      if (match) {
        found = variant;
      }
    });

    return found || null;
  }
}

var modals = {
  init: function(){
    $('body').on('click', '.modal-trigger', function(e){
      e.preventDefault();

      var target = $(this).attr('data-target');
      var modalContent = $(target);

      modalContent.addClass('product-modal-wrapper');

      $('body').append(modalContent);
    })

    $(document).mouseup(function (e){

      var container = $(".product-modal__content");
  
      if (!container.is(e.target) && container.has(e.target).length === 0){
        $('.product-modal-wrapper').removeClass('product-modal-wrapper');
      }
    });

    $('body').on('click', '.product-modal__close', function(){
      $('.product-modal-wrapper').removeClass('product-modal-wrapper');
    });

    $('body').on('click', '.addon_cta', function(){
      $('.product-modal-wrapper').removeClass('product-modal-wrapper');
    });

    $('body').on('click', '.addon-card__toggle', function(e){
      var target = $(e.target);
      modals.get_selected_values(target);
    });

    $('body').on('click', '.addon-card__learn-more', function(e){
      e.preventDefault();

      var target = $(this).attr('data-target');
      $(target).addClass('active');
      $(this).closest('.product-modal__content-content').addClass('read-more-open');
      $(this).closest('.product-modal__content-content').append($(target));
    })

    $('body').on('click', '.js-addon-more-back', function(e){
      e.preventDefault();

      $(this).closest('.product-modal__content-content').removeClass('read-more-open');
      $(this).closest('.product-modal__content-content').find('.active').removeClass('active');
    })
  },
  get_selected_values: function(target){
    var parent = target.closest('.product-addons');
    var contentParent = $('.product-form__addon');
    var i = 0;
    var selected_total_price = 0;
    var total_price = 0;

    target.closest('.addon-card__actions').toggleClass('active');
    parent.find('.addon-card__actions').each(function(){
      var price = $(this).find('.addon-card__toggle').attr('data-variant-price');
      if($(this).hasClass('active')){
        i++;
        selected_total_price = selected_total_price + parseInt(price);
        total_price = total_price + parseInt(price);
      }
    })    

    selected_total_price = theme.Currency.formatMoney(selected_total_price, window.settings.moneyFormat);
    total_price = total_price + parseInt($('.product-form__addon-price .product_price').attr('data-price'));
    
    if(i > 0){
      parent.find('.addon_cta span').text(`Add ${i} Items`);
      contentParent.find('.list-addons span').text(`${i} Items Selected`);
      contentParent.find('.product-form__addon--capsule').addClass('addons-selected');
      contentParent.find('.product-form__addon-edit').empty().append(`<span class="add-ons-money">${selected_total_price}</span><span class="edit-btn">Edit</span>`);
    }else{
      parent.find('.addon_cta span').text('Close');
      contentParent.find('.list-addons span').text(contentParent.find('.list-addons').attr('data-text'));
      contentParent.find('.product-form__addon--capsule').removeClass('addons-selected');
      contentParent.find('.product-form__addon-edit').empty().append(window.svgs.plus);
    }

    productForm.product_installment_update();
    productForm.product_price_update();
  },
  close: function(){
    
  }
}

$(document).ready(function(){

  productMediaWrapper.init();
  productMediaWrapper.color_swatch_slider();

  // productForm Js
  productForm.init();
  modals.init();

});

// $(window).on('load', function(){
//   const queryString = window.location.search;
//   const urlParams = new URLSearchParams(queryString);
//   var variantOptionsWrap = document.querySelector('variant-radios');

//   if(urlParams){
//     var selectedColor = urlParams.get('variant');
//     var selectedSize = urlParams.get('size');

//     console.log(selectedColor, selectedSize);

//     if(selectedColor){
//       $('.main-product-wrap').find('[name="Color"]').removeAttr('checked');
//       $('.main-product-wrap').find('[name="Color"][value="' + selectedColor + '"]').attr('checked', 'checked');
//     }
//     if(selectedSize){
//       $('.main-product-wrap').find('[name="Size"]').removeAttr('checked');
//       $('.main-product-wrap').find('[name="Size"][value="' + selectedSize + '"]').attr('checked', 'checked');
//     }

//     const e = new Event("change");
//     variantOptionsWrap.dispatchEvent(e);
//   }
// })